import gql from 'graphql-tag';

export const PageInfoFragment = gql`
	fragment PageInfoFragment on PageInfo {
		endCursor
		hasNextPage
		hasPreviousPage
		startCursor
	}
`;

export const CommentFragment = gql`
	fragment CommentFragment on CommentType {
		id
		objectId
		text
		author {
			contentType
			firstName
			lastName
			name
			psId
			smallAvatarUrl
			smallLogoUrl
			displayName
			imageUrl
		}
		created
		updated
		userKeycloackId
		sentAsEmail
	}
`;
